import { changePasswordAPI } from "@/apis/auth-api"
import { langStore } from "@/stores/lang-store"
import { myPageBundle } from "@/routes/my/my-page-const"
import PW_Input from "@/routes/my/_components/pw-input"

import { passwordChangeStore } from "@/routes/my/pw/change/pw-change-store"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
import PW_Card from "../../_components/pw-card"
import PW_SubmitButton from "../../_components/pw_submit-button"

const INITIAL_FORM = {
  newPassword: "",
  confirmPassword: ""
}

const PASSWORD_PATTERN = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d\s])\S{8,20}$/

const PWChangePage = () => {
  const navigate = useNavigate()
  const { lang } = langStore()
  const { verifiedPassword, reset } = passwordChangeStore()
  const [form, setForm] = useState(INITIAL_FORM)
  const [visible, setVisible] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const isCompletedRef = useRef(false)
  const bundle = myPageBundle.password

  useEffect(() => {
    if (!verifiedPassword && !isCompletedRef.current) {
      navigate("/my/pw/verify", { replace: true })
    }
  }, [verifiedPassword, navigate])

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (!PASSWORD_PATTERN.test(form.newPassword)) {
      toast.error(bundle.hint[lang])
      return
    }

    if (form.newPassword !== form.confirmPassword) {
      toast.error(bundle.mismatch[lang])
      return
    }

    try {
      setIsSubmitting(true)
      await changePasswordAPI({
        current_password: verifiedPassword,
        new_password: form.newPassword
      })
      isCompletedRef.current = true
      reset()
      toast.success(bundle.success[lang])
      navigate("/my", { replace: true })
    } catch (error) {
      toast.error(error?.response?.data?.detail ?? bundle.failure[lang])
    } finally {
      setIsSubmitting(false)
    }
  }

  if (!verifiedPassword) return null

  return (
    <PW_Card title={bundle.title[lang]} description={bundle.hint[lang]}>
      <form className="space-y-5" onSubmit={handleSubmit}>
        <PW_Input
          label={bundle.new[lang]}
          name="newPassword"
          value={form.newPassword}
          visible={visible.newPassword}
          onChange={(event) => setForm((prev) => ({ ...prev, newPassword: event.target.value }))}
          onToggle={() => setVisible((prev) => ({ ...prev, newPassword: !prev.newPassword }))}
          autoComplete="new-password"
          maxLength={20}
        />
        <PW_Input
          label={bundle.confirm[lang]}
          name="confirmPassword"
          value={form.confirmPassword}
          visible={visible.confirmPassword}
          onChange={(event) =>
            setForm((prev) => ({ ...prev, confirmPassword: event.target.value }))
          }
          onToggle={() =>
            setVisible((prev) => ({ ...prev, confirmPassword: !prev.confirmPassword }))
          }
          autoComplete="new-password"
          maxLength={20}
        />
        <PW_SubmitButton disabled={isSubmitting}>
          {isSubmitting ? bundle.submitting[lang] : bundle.submit[lang]}
        </PW_SubmitButton>
      </form>
    </PW_Card>
  )
}

export default PWChangePage
